module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmBAMAAABaE/SdAAAAHlBMVEUAAAD///////////////////////9KSkrFxcUzMzN2GkNXAAAABnRSTlMA88i9ZRljrLGUAAAAWUlEQVQoz2NgYFFMQwZCDgwMrGZpqCA5gIE5DR0YMLhhiKUwqGGIJTGIYYglMqRhgmElllHeBsNwsfSZZTCMXQxT74D7g8Zi2NIGtjSELa1hS5PY0i62NA4Ahi8asLLk8KUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/mobile/group.png
// module id = ae0L
// module chunks = 1